import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";

const Main = lazy(
  () => import("../components/examination/paymentSuccessful")
);

const PaymentSuccessful = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default PaymentSuccessful;